import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
  session_id: string().required(),
});

/**
 * SystemConnectEvent
 *
 * - Esse evento é enviado pelo servidor imediatamente após o cliente se conectar.
 */
export class SystemConnectEvent extends CreateCommand(RealtimeEventType.SystemConnect, SCHEMA) {}
